"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _querystring = _interopRequireDefault(require("querystring"));

var _omitBy = _interopRequireDefault(require("lodash/omitBy"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _default = {
  parse: function parse(search) {
    search = search.replace(/^\?/, '');
    return _querystring.default.parse(search);
  },
  stringify: function stringify(obj) {
    return _querystring.default.stringify((0, _omitBy.default)(obj, _isUndefined.default));
  }
};
exports.default = _default;